import { DebugStepOverIcon } from './DebugStepOverIcon';

/**
 * author: Austin Andrews
 * id 8242E7C8-1400-476D-AC27-DCA7B6292C70
 * name debug-step-over
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/debug-step-over.svg
 * tags
 */
export const JumpIcon = DebugStepOverIcon;
export default JumpIcon